import { render, staticRenderFns } from "./menu-editor.vue?vue&type=template&id=650b0e72&scoped=true&"
import script from "./menu-editor.vue?vue&type=script&lang=js&"
export * from "./menu-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650b0e72",
  null
  
)

/* custom blocks */
import block0 from "@/lang/actions.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ffabrika-klientov%2Fappearance%2Fwhite%2Fsrc%2Fcomponents%2Fmenu%2Fmenu-editor.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports